import './Landing.scss'
import { useDotnetClient } from '@/contexts/DotnetClientContext'
import { LandingWorkspaces } from './LandingWorkspaces'

export function LandingLoggedIn() {
  useDotnetClient()

  return (
    <>
      <div className="landing">
        <LandingWorkspaces />
      </div>
    </>
  )
}
